(function() {
    'use strict';

    var ScreeningCaseReferencePageCtrl = function ($http, $scope, $window, ajaxCall, $sce, xmsNotificationFactory) {
      $scope.untilPresentCheck = function(){
        $scope.candidateReferenceModel.candidateDateTo = '';
        $scope.candidateReferenceModel.refereeDateTo = '';
        $scope.candidateReferenceModel.dateTo = '';
        $scope.candidateReferenceModel.refereeDateToUntilPresent = $scope.candidateReferenceModel.candidateDateToUntilPresent;
        $scope.candidateReferenceModel.adminDateToUntilPresent = $scope.candidateReferenceModel.candidateDateToUntilPresent;
      }

      $scope.untilPresentCheckReferee= function(){
        if($scope.candidateReferenceModel.refereeDateToUntilPresent)
          $scope.candidateReferenceModel.refereeDateTo     = '';
      }

      $scope.untilPresentCheckAdmin = function(){
        if($scope.candidateReferenceModel.adminDateToUntilPresent)
          $scope.candidateReferenceModel.dateTo     = '';
      }

      if($scope.candidateReferenceModel.actionType == 'create') {
        $scope.candidateReferenceModel.candidateDateFrom = '';
        $scope.candidateReferenceModel.refereeDateFrom   = '';
        $scope.candidateReferenceModel.dateFrom          = '';
        $scope.candidateReferenceModel.candidateDateTo   = '';
        $scope.candidateReferenceModel.refereeDateTo     = '';
        $scope.candidateReferenceModel.dateTo            = '';
        $scope.candidateReferenceModel.firstReminder     = '';
        $scope.candidateReferenceModel.secondReminder    = '';
        $scope.candidateReferenceModel.refereeDateToUntilPresent    = false;
        $scope.candidateReferenceModel.candidateDateToUntilPresent  =  false;
        $scope.candidateReferenceModel.adminDateToUntilPresent  =  false;

        // $scope.candidateReferenceModel.candJobTitleHeldForCand = '';
        // $scope.candidateReferenceModel.candJobTitleHeldForRefr = '';
      }

      $scope.candidateReferenceModel.disableSubmit = false;


      var ajaxCallList = function(ajaxUrl, data) {
        var errorMsg = 'Error';
        ajaxCall.getData(ajaxUrl, data).then(
          function(result) {
            xmsNotificationFactory.addObj({id: "candRefPop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
          },
          function(result) {
            $scope.candidateReferenceModel.htmlOutput = $sce.trustAsHtml(errorMsg);
          }
        );
      }

      $scope.changeReferenceType=function(){
        console.log("changeReferenceType !!!!"+ $scope.candidateReferenceModel.referenceType);
        console.log("URL ::: "+WEBAPP_PATH);
        var referenceType = $scope.candidateReferenceModel.referenceType;
        var subcheckId = $scope.candidateReferenceModel.subcheckId;
        //$scope.candidateReferenceModel.onlineDisplayReferenceId = '';
        var selectedValue =  $scope.candidateReferenceModel.onlineDisplayReferenceId;

        if(referenceType == 5128){
          $scope.candidateReferenceModel.candidateDateToUntilPresent = true;
          $scope.candidateReferenceModel.refereeDateToUntilPresent = true;
          $scope.candidateReferenceModel.adminDateToUntilPresent = true;

        }

        var url = '/screeningCaseReference/referenceTypeDetails'
        $http.get(WEBAPP_PATH+url+'?referenceType='+referenceType+'&subcheckId='+subcheckId)
          .then(
            function(response){
              $scope.referenceTemplateList = response.data.referenceTemplateList;
              if ($scope.referenceTemplateList.length == 1) {
                $scope.candidateReferenceModel.onlineDisplayReferenceId = $scope.referenceTemplateList[0];
              } else {
                $scope.candidateReferenceModel.onlineDisplayReferenceId = $scope.referenceTemplateList.find(function(it){ return it.id == selectedValue || (selectedValue && it.id == selectedValue.id); });
              }
            });
      }

      $scope.submitForm = function($event) {
        //adding this as a hack since disable-on-submit is not working.
        // $('#candReferencePopupForm').find("button[type='submit']").prop('disabled',true);
        console.log("INSIDE submitForm");
        $scope.candidateReferenceModel.disableSubmit = true;

        $event.preventDefault();

        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/save";

        if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
          // this will never happen, so do we need that if?

          var fd = new FormData(),
            c = 0,
            file_data;


          $('input[type="file"]').each(function(){
            file_data = $('input[type="file"]')[c].files; // for multiple files
            // this is bad idea to use jQuery inside any Angular code
            // please replace that with ng-model on your inputs, then you can access your data

            for(var i = 0; i<file_data.length; i++){
              fd.append("file_"+c, file_data[i]);
              fd.append("file_params_" + c, $(this).attr('attachmentlinkparams'));
            }
            c++;
          });

          var ajaxData = $('#candReferencePopupForm').serializeArray();

          $.each(ajaxData,function(key,input){ // please use angular.forEach function instead $.each
            fd.append( input.name, input.value );
            // the above should be done by ng-repeat in your template, so probably you may not need the whole thing in here...
          });
          // ajaxCallList(ajaxUrl,fd);
          $http({
            method: "post",
            url: ajaxUrl,
            data: fd,
            headers: {'Content-Type': undefined},
            transformRequest: angular.identity
          }).then(function(response){
            // $scope.candidateReferenceModel.htmlOutput = $sce.trustAsHtml(response.data);
            console.log(response.data);
            xmsNotificationFactory.addObj({id: "saveCandReference", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout:10});
            xmsNotificationFactory.bulk(response.data.attachmentErrors);
          });
        }
      }


      $scope.updateForm = function($event) {
        console.log("INSIDE updateForm");
        console.log("$scope.candidateReferenceModel.smartTableRefreshCounter");
        console.log($scope.candidateReferenceModel.smartTableRefreshCounter);
        $event.preventDefault();

        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/update";

        if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
          // this will never happen, so do we need that if?

          var fd = new FormData(),
            c = 0,
            file_data;

          $('input[type="file"]').each(function(){
            file_data = $('input[type="file"]')[c].files; // for multiple files
            for(var i = 0;i<file_data.length;i++){
              fd.append("file_"+c, file_data[i]);
              fd.append("file_params_" + c, $(this).attr('attachmentlinkparams'));
            }
            c++;
          });
          var ajaxData = $('#candReferencePopupForm').serializeArray();
          $.each(ajaxData,function(key,input){
            fd.append(input.name,input.value);
          });
          $http({
            method: "post",
            url: ajaxUrl,
            data: fd,
            headers: {'Content-Type': undefined},
            transformRequest: angular.identity
          }).then(
            function(response){
              // $scope.candidateReferenceModel.htmlOutput = $sce.trustAsHtml(response.data);
              console.log(response.data);
              xmsNotificationFactory.addObj({id: "updateCandReference", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout:10});
            });
        }
      }

      $scope.sendOnlineRefRequest = function($event) {
        console.log("INSIDE sendOnlineRefRequest");
        $event.preventDefault();

        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/sendOnlineRefRequest?refId="+$scope.candidateReferenceModel.candidateReferenceId

        if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
          // this will never happen, so do we need that if?
          var ajaxData = $('#candReferencePopupForm').serialize();
          // the above should be done with ng-model on your form fields
          // then you have all your form data in $scope.yourModel variable so you don't need that :)
          ajaxCallList(ajaxUrl , ajaxData);
        }
      }

      $scope.verifyReference = function($event) {
        if($scope.candidateReferenceModel.refereeFirstName.length=='0'){
          $scope.isError = true;
          $scope.errorMsg ='First Name should not be null'
        }
        if($scope.candidateReferenceModel.refereeLastName.length=='0'){
          $scope.isError = true;
          $scope.errorMsg ='Last Name should not be null'
        }

        $event.preventDefault();

        var ajaxUrl = WEBAPP_PATH + "/preVerifiedReferee/verifyRefereeDetails";

        if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
          var ajaxData = $('#candReferencePopupForm').serialize();

          ajaxCallList(ajaxUrl , ajaxData);
        }
      }
      $scope.updateRefereeDetails = function($event) {
        $event.preventDefault();

        var ajaxUrl = WEBAPP_PATH + "/preVerifiedReferee/updateRefereeDetails?refereeEmail="+$scope.candidateReferenceModel.refereeEmail;

        if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
          var ajaxData = $('#candReferencePopupForm').serialize();
          ajaxCallList(ajaxUrl , ajaxData);
        }
      }

      $scope.verifyRefereeDetails = function($event) {
        $event.preventDefault();

        var ajaxUrl = WEBAPP_PATH + "/preVerifiedReferee/verifyRefereeDetails?refereeEmail="+$scope.candidateReferenceModel.refereeEmail;

        if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
          var ajaxData = $('#candReferencePopupForm').serialize();
          ajaxCallList(ajaxUrl , ajaxData);
        }
      }
      $scope.viewOnlineReference = function($event,onlineRefUrl) {
        console.log("INSIDE viewOnlineReference");
        $event.preventDefault();
        $window.open(onlineRefUrl);
      }

      $scope.viewRefHistory = function($event,refHistoryUrl) {
        console.log("INSIDE viewRefHistory");
        $event.preventDefault();
        $window.open(refHistoryUrl);
      }

      $scope.overruleConfirm = function($event) {
        console.log("Inside overruleConfirm() function");
        $event.preventDefault();

        var candReferenceIdList = $scope.candidateReferenceModel.candidateReferenceIdList;
        var overruledComments = $scope.candidateReferenceModel.overruledComments;
        var candId = $scope.candidateReferenceModel.candId;
        var data = 'candReferenceIdList=' + candReferenceIdList + '&overruledComments=' + overruledComments + '&candId=' + candId;
        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/overruledConfirm";

        ajaxCallList(ajaxUrl , data);
      }

      $scope.passConfirm = function($event) {
        console.log("Inside passConfirm() function");
        $event.preventDefault();

        var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
        var candId = $scope.candidateReferenceModel.candId;
        var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/pass";

        ajaxCallList(ajaxUrl , data);
      }

      $scope.failConfirm = function($event) {
        console.log("Inside failConfirm() function");
        $event.preventDefault();

        var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
        var candId = $scope.candidateReferenceModel.candId;
        var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/fail";

        ajaxCallList(ajaxUrl , data);
      }

      $scope.referenceReceivedConfirm = function($event) {
        console.log("Inside referenceReceivedConfirm() function");
        $event.preventDefault();

        var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
        var candId = $scope.candidateReferenceModel.candId;
        var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/referenceReceived";

        ajaxCallList(ajaxUrl , data);
      }

      $scope.dayDiff = function(candidateDate, refereeDate){
        var diffDays = 0;
        if( angular.isDefined(candidateDate) && angular.isDefined(refereeDate) ){
          var date2 = new Date(candidateDate);
          var date1 = new Date(refereeDate);
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        }
        return diffDays;
      }
    }

  ScreeningCaseReferencePageCtrl.$inject = [
    '$http',
    '$scope',
    '$window',
    'ajaxCall',
    '$sce',
    'xmsNotificationFactory'
  ];
  angular.module('app').controller('ScreeningCaseReferencePageCtrl',ScreeningCaseReferencePageCtrl);

    var ScreeningCaseReferenceCtrl = function ($http, $scope, $uibModalInstance, $window, ajaxCall, $sce, passedModel,xmsNotificationFactory) {

        if( !angular.isDefined(passedModel) ){
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }

        console.log("INSIDE ScreeningCaseReferenceCtrl");
        $scope.candidateReferenceModel = passedModel;

        $scope.untilPresentCheck = function(){
            $scope.candidateReferenceModel.candidateDateTo = '';
            $scope.candidateReferenceModel.refereeDateTo = '';
            $scope.candidateReferenceModel.dateTo = '';
            $scope.candidateReferenceModel.refereeDateToUntilPresent = $scope.candidateReferenceModel.candidateDateToUntilPresent;
            $scope.candidateReferenceModel.adminDateToUntilPresent = $scope.candidateReferenceModel.candidateDateToUntilPresent;
        }

        $scope.untilPresentCheckReferee= function(){

            if($scope.candidateReferenceModel.refereeDateToUntilPresent)
                $scope.candidateReferenceModel.refereeDateTo     = '';

        }

         $scope.untilPresentCheckAdmin = function(){

            if($scope.candidateReferenceModel.adminDateToUntilPresent)
                $scope.candidateReferenceModel.dateTo     = '';

         }



        if($scope.candidateReferenceModel.actionType == 'create') {
            $scope.candidateReferenceModel.candidateDateFrom = '';
            $scope.candidateReferenceModel.refereeDateFrom   = '';
            $scope.candidateReferenceModel.dateFrom          = '';
            $scope.candidateReferenceModel.candidateDateTo   = '';
            $scope.candidateReferenceModel.refereeDateTo     = '';
            $scope.candidateReferenceModel.dateTo            = '';
            $scope.candidateReferenceModel.firstReminder     = '';
            $scope.candidateReferenceModel.secondReminder    = '';
            $scope.candidateReferenceModel.refereeDateToUntilPresent    = false;
            $scope.candidateReferenceModel.candidateDateToUntilPresent  =  false;
            $scope.candidateReferenceModel.adminDateToUntilPresent  =  false;

            // $scope.candidateReferenceModel.candJobTitleHeldForCand = '';
            // $scope.candidateReferenceModel.candJobTitleHeldForRefr = '';
        }

        $scope.candidateReferenceModel.disableSubmit = false;


        var ajaxCallList = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.candidateReferenceModel.smartTableRefreshCounter++;
                    xmsNotificationFactory.addObj({id: "candRefPop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.candidateReferenceModel);
                },
                function(result) {
                    $scope.candidateReferenceModel.htmlOutput = $sce.trustAsHtml(errorMsg);
                }
            );
        }

        $scope.changeReferenceType=function(){
            console.log("changeReferenceType !!!!"+ $scope.candidateReferenceModel.referenceType);
            console.log("URL ::: "+WEBAPP_PATH);
            var referenceType = $scope.candidateReferenceModel.referenceType;
            var subcheckId = $scope.candidateReferenceModel.subcheckId;
            //$scope.candidateReferenceModel.onlineDisplayReferenceId = '';
            var selectedValue =  $scope.candidateReferenceModel.onlineDisplayReferenceId;

            if(referenceType == 5128){
                $scope.candidateReferenceModel.candidateDateToUntilPresent = true;
                $scope.candidateReferenceModel.refereeDateToUntilPresent = true;
                $scope.candidateReferenceModel.adminDateToUntilPresent = true;

            }

            var url = '/screeningCaseReference/referenceTypeDetails'
            $http.get(WEBAPP_PATH+url+'?referenceType='+referenceType+'&subcheckId='+subcheckId)
                .then(
                    function(response){
                        $scope.referenceTemplateList = response.data.referenceTemplateList;
                        if ($scope.referenceTemplateList.length == 1) {
                            $scope.candidateReferenceModel.onlineDisplayReferenceId = $scope.referenceTemplateList[0];
                        } else {
                            $scope.candidateReferenceModel.onlineDisplayReferenceId = $scope.referenceTemplateList.find(function(it){ return it.id == selectedValue || (selectedValue && it.id == selectedValue.id); });
                        }
                    });
        }

        $scope.submitForm = function($event) {
            //adding this as a hack since disable-on-submit is not working.
            // $('#candReferencePopupForm').find("button[type='submit']").prop('disabled',true);
            console.log("INSIDE submitForm");
            $scope.candidateReferenceModel.disableSubmit = true;

            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/save";

            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                // this will never happen, so do we need that if?

                var fd = new FormData(),
                    c = 0,
                    file_data;


                $('input[type="file"]').each(function(){
                    file_data = $('input[type="file"]')[c].files; // for multiple files
                    // this is bad idea to use jQuery inside any Angular code
                    // please replace that with ng-model on your inputs, then you can access your data

                    for(var i = 0; i<file_data.length; i++){
                        fd.append("file_"+c, file_data[i]);
                        fd.append("file_params_" + c, $(this).attr('attachmentlinkparams'));
                    }
                    c++;
                });

                var ajaxData = $('#candReferencePopupForm').serializeArray();

                $.each(ajaxData,function(key,input){ // please use angular.forEach function instead $.each
                    fd.append( input.name, input.value );
                    // the above should be done by ng-repeat in your template, so probably you may not need the whole thing in here...
                });
                // ajaxCallList(ajaxUrl,fd);
                $http({
                    method: "post",
                    url: ajaxUrl,
                    data: fd,
                    headers: {'Content-Type': undefined},
                    transformRequest: angular.identity
                }).then(function(response){
                    $scope.candidateReferenceModel.smartTableRefreshCounter++;
                    // $scope.candidateReferenceModel.htmlOutput = $sce.trustAsHtml(response.data);
                    console.log(response.data);
                    xmsNotificationFactory.addObj({id: "saveCandReference", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.candidateReferenceModel);
                    xmsNotificationFactory.bulk(response.data.attachmentErrors);
                });
            }
        }


        $scope.updateForm = function($event) {
            console.log("INSIDE updateForm");
            console.log("$scope.candidateReferenceModel.smartTableRefreshCounter");
            console.log($scope.candidateReferenceModel.smartTableRefreshCounter);
            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/update";

            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                // this will never happen, so do we need that if?

                var fd = new FormData(),
                    c = 0,
                    file_data;

                $('input[type="file"]').each(function(){
                    file_data = $('input[type="file"]')[c].files; // for multiple files
                    for(var i = 0;i<file_data.length;i++){
                        fd.append("file_"+c, file_data[i]);
                        fd.append("file_params_" + c, $(this).attr('attachmentlinkparams'));
                    }
                    c++;
                });
                var ajaxData = $('#candReferencePopupForm').serializeArray();
                $.each(ajaxData,function(key,input){
                    fd.append(input.name,input.value);
                });
                $http({
                    method: "post",
                    url: ajaxUrl,
                    data: fd,
                    headers: {'Content-Type': undefined},
                    transformRequest: angular.identity
                }).then(
                    function(response){
                        $scope.candidateReferenceModel.smartTableRefreshCounter++;
                        // $scope.candidateReferenceModel.htmlOutput = $sce.trustAsHtml(response.data);
                        console.log(response.data);
                        xmsNotificationFactory.addObj({id: "updateCandReference", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout:10});
                        $uibModalInstance.close($scope.candidateReferenceModel);
                    });
            }
        }

        $scope.sendOnlineRefRequest = function($event) {
            console.log("INSIDE sendOnlineRefRequest");
            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/sendOnlineRefRequest?refId="+$scope.candidateReferenceModel.candidateReferenceId


            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                // this will never happen, so do we need that if?
                var ajaxData = $('#candReferencePopupForm').serialize();
                // the above should be done with ng-model on your form fields
                // then you have all your form data in $scope.yourModel variable so you don't need that :)
                ajaxCallList(ajaxUrl , ajaxData);
            }
        }


        $scope.verifyReference = function($event) {
            var errorMsg = 'Error';
            if($scope.candidateReferenceModel.refereeFirstName.length=='0'){
                $scope.isError = true;
                $scope.errorMsg ='First Name should not be null'
            }
            if($scope.candidateReferenceModel.refereeLastName.length=='0'){
                $scope.isError = true;
                $scope.errorMsg ='Last Name should not be null'
            }

            $event.preventDefault();


            var ajaxUrl = WEBAPP_PATH + "/preVerifiedReferee/verifyRefereeDetails";

            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                var ajaxData = $('#candReferencePopupForm').serialize();

                ajaxCallList(ajaxUrl , ajaxData);
            }
        }
        $scope.updateRefereeDetails = function($event) {
            $event.preventDefault();


            var ajaxUrl = WEBAPP_PATH + "/preVerifiedReferee/updateRefereeDetails?refereeEmail="+$scope.candidateReferenceModel.refereeEmail;


            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                var ajaxData = $('#candReferencePopupForm').serialize();
                ajaxCallList(ajaxUrl , ajaxData);
            }
        }


        $scope.verifyRefereeDetails = function($event) {
            $event.preventDefault();


            var ajaxUrl = WEBAPP_PATH + "/preVerifiedReferee/verifyRefereeDetails?refereeEmail="+$scope.candidateReferenceModel.refereeEmail;

            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                var ajaxData = $('#candReferencePopupForm').serialize();
                ajaxCallList(ajaxUrl , ajaxData);
            }
        }






        $scope.viewOnlineReference = function($event,onlineRefUrl) {
            console.log("INSIDE viewOnlineReference");
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
            $window.open(onlineRefUrl);
        }

        $scope.viewRefHistory = function($event,refHistoryUrl) {
            console.log("INSIDE viewRefHistory");
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
            $window.open(refHistoryUrl);
        }

        $scope.overruleConfirm = function($event) {
            console.log("Inside overruleConfirm() function");
            $event.preventDefault();

            var errorMsg = 'Error';
            var candReferenceIdList = $scope.candidateReferenceModel.candidateReferenceIdList;
            var overruledComments = $scope.candidateReferenceModel.overruledComments;
            var candId = $scope.candidateReferenceModel.candId;
            var data = 'candReferenceIdList=' + candReferenceIdList + '&overruledComments=' + overruledComments + '&candId=' + candId;
            var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/overruledConfirm";

            ajaxCallList(ajaxUrl , data);
        }

        $scope.passConfirm = function($event) {
            console.log("Inside passConfirm() function");
            $event.preventDefault();

            var errorMsg = 'Error';
            var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
            var candId = $scope.candidateReferenceModel.candId;
            var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
            var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/pass";

            ajaxCallList(ajaxUrl , data);
        }

      $scope.confirmMarkasReceived = function($event) {
        console.log("Inside markAsReceived() function");
        $event.preventDefault();

        var errorMsg = 'Error';
        var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
        var candId = $scope.candidateReferenceModel.candId;
        var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/markAsReceived";

        ajaxCallList(ajaxUrl , data);
      }

      $scope.confirmAutoReviewPass = function($event) {
        console.log("Inside confirmAutoReviewPass() function");
        $event.preventDefault();

        var errorMsg = 'Error';
        var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
        var candId = $scope.candidateReferenceModel.candId;
        var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/autoreviewPass";

        ajaxCallList(ajaxUrl , data);
      }

      $scope.confirmAutoReviewFail = function($event) {
        console.log("Inside confirmAutoReviewFail() function");
        $event.preventDefault();

        var errorMsg = 'Error';
        var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
        var candId = $scope.candidateReferenceModel.candId;
        var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
        var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/autoreviewFail";

        ajaxCallList(ajaxUrl , data);
      }




        $scope.failConfirm = function($event) {
            console.log("Inside failConfirm() function");
            $event.preventDefault();

            var errorMsg = 'Error';
            var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
            var candId = $scope.candidateReferenceModel.candId;
            var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
            var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/fail";

            ajaxCallList(ajaxUrl , data);
        }

        $scope.referenceReceivedConfirm = function($event) {
            console.log("Inside referenceReceivedConfirm() function");
            $event.preventDefault();

            var errorMsg = 'Error';
            var candReferenceId = $scope.candidateReferenceModel.candidateReferenceId;
            var candId = $scope.candidateReferenceModel.candId;
            var data = 'candReferenceId=' + candReferenceId + '&candId=' + candId;
            var ajaxUrl = WEBAPP_PATH + "/screeningCaseReference/referenceReceived";

            ajaxCallList(ajaxUrl , data);
        }

        $scope.dayDiff = function(candidateDate, refereeDate){
            var diffDays = 0;
            if( angular.isDefined(candidateDate) && angular.isDefined(refereeDate) ){
                var date2 = new Date(candidateDate);
                var date1 = new Date(refereeDate);
                var timeDiff = Math.abs(date2.getTime() - date1.getTime());
                diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            }
            return diffDays;
        }

        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

    }
    ScreeningCaseReferenceCtrl.$inject = ['$http','$scope','$uibModalInstance','$window','ajaxCall', '$sce', 'params','xmsNotificationFactory'];
    angular.module('app').controller('ScreeningCaseReferenceCtrl',ScreeningCaseReferenceCtrl);

}());
